import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, inject, input } from '@angular/core';
import { IQuizViewItem } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz';
import { FiQuizQuestionType } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-enums';
import { IItemsListAction2 } from '@fi-app/shared/fi-items-list/fi-items-list';
import { FiQuizActionsBuilderService } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-actions-builder.service';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { SideListOptionType } from '@fi-app/shared/types';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

@Component({
    selector: 'fi-quiz-view',
    templateUrl: './fi-quiz-view.component.html',
    styleUrls: ['./fi-quiz-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { class: 'fi-quiz-view' },
})
export class FiQuizViewComponent {
    @Input({ required: true }) quizViewer: IQuizViewItem;
    private fiQuizActionsBuilderService = inject(FiQuizActionsBuilderService);
    private readonly fiStateService = inject(FiStateService);

    protected readonly actions: IItemsListAction2<IQuizViewItem>[] = this.fiQuizActionsBuilderService.getQuizActions({
        onQuizDeletedFn: () =>
            this.fiStateService.go(FiStateNames.Onboarding.Quiz.List, { filterType: SideListOptionType.SharedWithMe }),
    });

    protected back(): void {
        window.history.back();
    }

    protected isSingleChoiceQuestion(questionType: FiQuizQuestionType): boolean {
        return questionType === FiQuizQuestionType.SingleAnswer;
    }
}
